import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { CompanyInternalNumberValidator } from 'src/app/shared/validators/company-internal-number.validator';
import { ICompany, IUpdateCompanyRequest } from '../models/company';
import { CompanyService } from '../services/company.service';
import { Observable } from 'rxjs';
import { companySelector } from 'src/app/stores/global/companies/company-selectors';
import { select, Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/stores/appState.interface';
import * as CompanyActions from "../../stores/global/companies/company-actions";
import { SelectEvent } from '@progress/kendo-angular-layout';


@Component({
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['./company.component.scss'],
    standalone: false
})
export class CompanyComponent implements OnInit {

  public company : ICompany;

  constructor(
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private appNotificationService: AppNotificationService,
    private router: Router,
    private store: Store<AppStateInterface>
  ) { 
    this.company = this.route.snapshot.data['company'] as ICompany;
  }

  form: UntypedFormGroup;

  ngOnInit(): void {
    this.initForm(this.company)
  }

  initForm(company: ICompany){
    this.form = new UntypedFormGroup({
      id: new UntypedFormControl(company.id),
      name: new UntypedFormControl(company.name, {
        validators: Validators.required,
        updateOn: 'blur'}),
      tenantId: new UntypedFormControl(company.tenantId),
      orderCopyEmail: new UntypedFormControl(company.orderCopyEmail, Validators.email),
      internalNumber: new UntypedFormControl(company.internalNumber, {
        validators: Validators.required,
        asyncValidators: CompanyInternalNumberValidator(this.companyService),
        updateOn: 'blur'}),
    })
  }

  onSubmit(){
    const formValues = this.form.value;
    const request : IUpdateCompanyRequest = {
      id: formValues.id,
      name: formValues.name,
      orderCopyEmail: formValues.orderCopyEmail,
      internalNumber: formValues.internalNumber,
    }
    this.companyService.updateCompany(request)
    .subscribe(response => {
      this.router.navigate(['/companies']);
      this.appNotificationService.notification$.next({message: translate('companies.updateSuccess'), style: "success"});
    })
  }

  // tab element
  public onTabSelect(e: SelectEvent): void {
  }
}
